import { memo } from 'react';
import type { FormFieldOptionData } from '@/services/api-types';

export interface OptionsEditorProps {
  options: FormFieldOptionData[];
  onAdd: () => void;
  onRemove: (idx: number) => void;
  onMove: (idx: number, delta: 1 | -1) => void;
  onUpdate: (idx: number, patch: Partial<FormFieldOptionData>) => void;
}

export const OptionsEditor = memo(function OptionsEditor({
  options,
  onAdd,
  onRemove,
  onMove,
  onUpdate,
}: OptionsEditorProps) {
  return (
    <div className="kst-fb-options">
      <label className="kstc-label">Options</label>
      <table className="kst-fb-options-table">
        <thead>
          <tr>
            <th title="The value saved when this option is picked. This is hidden from the form.">Saved as</th>
            <th title="What appears on the form when filling it out.">Shown on the form</th>
            <th style={{ width: 110 }} />
          </tr>
        </thead>
        <tbody>
          {options.length === 0 && (
            <tr className="kst-fb-options-table-empty">
              <td colSpan={3}>No options yet. Click "Add option".</td>
            </tr>
          )}
          {options.map((opt, i) => (
            <tr key={`opt-${i}`}>
              <td>
                <input
                  type="text"
                  className="kstc-input"
                  value={opt.value}
                  onChange={(e) => onUpdate(i, { value: e.target.value })}
                  style={{ fontFamily: 'Menlo, Consolas, monospace' }}
                />
              </td>
              <td>
                <input
                  type="text"
                  className="kstc-input"
                  value={opt.label}
                  onChange={(e) => onUpdate(i, { label: e.target.value })}
                />
              </td>
              <td>
                <span className="kst-fb-actions">
                  <button type="button" className="kstc-btn kstc-btn--secondary" onClick={() => onMove(i, -1)} disabled={i === 0}>↑</button>
                  <button type="button" className="kstc-btn kstc-btn--secondary" onClick={() => onMove(i, 1)} disabled={i === options.length - 1}>↓</button>
                  <button type="button" className="kstc-btn kstc-btn--danger" onClick={() => onRemove(i)}>×</button>
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button type="button" className="kstc-btn kstc-btn--secondary" onClick={onAdd} style={{ marginTop: 6 }}>
        + Add option
      </button>
    </div>
  );
});
